import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import appRoutes, {
  inviteRoute,
  tournamentBracketRoute,
  tournamentFormRoutes
} from './app'
import draftRoute from '@/modules/draft/routes'
import i18n from '@/lang'
import settings from '@/settings'
import { isElectron } from '@/utils/electron'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'

import campaignRoutes from '@/modules/campaign/routes'
import store from '@/store'

Vue.use(VueRouter)
// Import all of the resource store files.

const routes = [
  appRoutes,
  inviteRoute,
  campaignRoutes,
  tournamentBracketRoute,
  tournamentFormRoutes,
  draftRoute,
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: isElectron() ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
})

const getPageTitle = (key: string) => {
  if (key) {
    const hasKey = i18n.te(`route.${key}`)
    if (hasKey) {
      const pageName = i18n.t(`route.${key}`)
      return `${pageName} - ${settings.title}`
    }
    return `${key} - ${settings.title}`
  }
  return `${settings.title}`
}

router.afterEach((to: Route) => {
  document.title = getPageTitle(to.meta.title)
  window.scrollTo(0, 0)
})

// router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidc'))

export default router
